/* eslint-disable camelcase */
import React from 'react'

import ChipRectangle from 'components/ChipRectangle'
import useSelector from 'hooks/use-selector'
import isJustDroppedCollectionProductSelect from 'modules/product/redux/selectors/should-hide-just-dropped-badge'

const JUST_DROPPED = 'Just Dropped'

/**
 * @param {ProductBadgesProps} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductBadgeJustDropped (props) {
  const {
    wasJustDropped,
    isTrending,
    isViralOnTikTok,
    showJustDroppedAndTrending,
    isEquinoxLoves,
    isAllures2024TopPicks,
    isBlackOwned
  } = props

  const isJustDroppedCollection = useSelector(isJustDroppedCollectionProductSelect)
  if (isJustDroppedCollection) {
    return <></>
  }

  if (
    (
      !wasJustDropped ||
      isTrending ||
      isViralOnTikTok ||
      isEquinoxLoves ||
      isAllures2024TopPicks ||
      isBlackOwned

    ) && !showJustDroppedAndTrending
  ) {
    return <></>
  }

  return (
    <ChipRectangle>
      {JUST_DROPPED}
    </ChipRectangle>
  )
}
